import * as React from "react";
import {Field, FieldWrapper, Form, FormElement} from "@progress/kendo-react-form";
import {Button} from "@progress/kendo-react-buttons";
import {Card, CardBody, CardSubtitle} from "@progress/kendo-react-layout";
import {Input} from "@progress/kendo-react-inputs";
import {confirmPasswordValidator, emailValidator, passwordValidator} from "../../../helpers/Validators";
import {subscriptionUserAPI} from "../../../../../../utilities/api";
import {isNullOrEmptyString} from "@progress/kendo-data-query/dist/npm/utils";
import {useParams} from "react-router-dom";
import PasswordForm from "../../../helpers/PasswordForm";

export const PasswordResetSteps = (props: any) => {
    const [step, setStep] = React.useState<number>(props.passwordStep ? 2 : 0);
    const [error, setError] = React.useState<string>("");
    const { passwordToken } = useParams();

    const submitEmail = async (dataItem: { [name: string]: any }) => {
        localStorage.setItem("subscriptionEmail", dataItem.email);

        await subscriptionUserAPI.initiatePasswordReset(dataItem.email)
            .then( () => {
                setStep(1);
                setError("");
            }).catch( (error) => {
                setError(error.response.data.message);
            });
    };

    const submitPasswordReset = async (dataItem: { [name: string]: any }) => {
        const passwordTokenString = passwordToken ?? "";
        const subscriptionEmail = localStorage.getItem("subscriptionEmail") ?? "";

        await subscriptionUserAPI.resetPassword(subscriptionEmail, dataItem.password, dataItem.confirm_password, passwordTokenString)
            .then( () => {
                props.passwordSet();
                setStep(3);
                window.history.replaceState(null, "", "/")
            }).catch( (error) => {
                setError(error.response.data.message);
            });
    }


    return (
        <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>

            { !isNullOrEmptyString(error) &&<p style={{color: "red"}}>{error}</p>}

            {step === 0 ?

                <Form
                    onSubmit={submitEmail}
                    render={() => (
                        <FormElement>
                            <div style={{alignSelf: "center"}}>
                                <div style={{color: "#3271E7", width: "30vw"}}>
                                    <FieldWrapper>
                                        <Field name={"email"} component={Input} labelclassname={"k-form-label"}
                                               label={"Please Enter your Email Address to Continue"}
                                               validator={emailValidator}/>
                                    </FieldWrapper>
                                </div>
                                <div
                                    style={{justifyContent: "space-between", alignContent: "center", marginTop: "20px"}}
                                    className={"k-form-buttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-bases-end"}>
                                    <div>
                                        <Button themeColor={"primary"} disabled={false} type={"submit"}>
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </FormElement>
                    )}
                />

                : null}


            {step === 1 ?
                <div>
                    <h2>Check Your Email for an Activation Link</h2>
                </div>
                : null}

            {step === 2 ?
                <Form
                    onSubmit={submitPasswordReset}
                    render={() => (
                        <FormElement>
                            <div style={{alignSelf: "center"}}>
                                <div style={{width: "30vw"}}>
                                    <Card>
                                        <CardSubtitle style={{textAlign: "left", border: "none"}}>
                                            <PasswordForm />
                                        </CardSubtitle>
                                        <CardBody style={{background: "#3271E7"}}>
                                            <FieldWrapper>
                                                <Field name={"password"} component={Input}
                                                       labelclassname={"k-form-label"}
                                                       label={"Password"} type={"password"}
                                                       validator={passwordValidator}/>
                                                <Field name={"confirm_password"} component={Input}
                                                       labelclassname={"k-form-label"}
                                                       label={"Confirm Password"} type={"password"}
                                                       validator={confirmPasswordValidator}/>
                                            </FieldWrapper>
                                        </CardBody>
                                    </Card>
                                </div>

                                <div
                                    style={{justifyContent: "space-between", alignContent: "center", marginTop: "20px"}}
                                    className={"k-form-buttons k-button k-button-md k-rounded-md k-button-solid k-button-solid-bases-end"}>
                                    <div>
                                        <Button themeColor={"primary"} type={"submit"}>
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </FormElement>
                    )}
                />
                : null}


            {step === 3 ?
                <div>
                    <h2>Password has been Reset Successfully</h2>
                </div>
                : null}

        </div>
    );
};
